import axios from "axios";
import { GET_VERSIONS_URL } from "../ApiConstant";

export const versionsLoading = () => {
  return {
    type: "LOADING_VERSIONS",
  };
};

export const versionsSuccess = (data) => {
  return {
    type: "VERSIONS_SUCCESS",
    data: data,
  };
};

export const versionsError = (err) => {
  return {
    type: "VERSIONS_ERROR",
    err: err,
  };
};

// export const getVersions = () => {
//   return (dispatch) => {
//     dispatch(versionsLoading());
//     axios
//       .get(GET_VERSIONS_URL)
//       .then((resp) => {
//         dispatch(versionsSuccess(resp.data));
//         localStorage.setItem("contentVersion", JSON.stringify(resp.data));
//       })
//       .catch((err) => {
//         dispatch(versionsError(err));
//       });
//   };
// };
export const getVersions = () => {

  return (dispatch) => {
    const cachedVersion = localStorage.getItem("contentVersion");
    if (cachedVersion) {
      dispatch(versionsSuccess(JSON.parse(cachedVersion)));
      return;
    }else{
      let jsn = JSON.stringify({"id":"10","url":"breezenew.itone.biz/","cdn_url":"siteContent/breezenew.itone.biz/","en":"3.2","cn":"1.4","hin":"0.7","telugu":"0.6","tamil":"0.6","arabic":"0.6","japanese":"0.3","korean":"0.3","thai":"0.2","modifyDate":"2024-07-18T21:23:40.000Z","domain":"ballysbreeze.com"}) 
      localStorage.setItem("contentVersion", jsn);
      dispatch(versionsSuccess(jsn));
    }

    dispatch(versionsLoading());
    axios
      .get(GET_VERSIONS_URL)
      .then((resp) => {
        dispatch(versionsSuccess(resp.data));
        localStorage.setItem("contentVersion", JSON.stringify(resp.data));
        
      })
      .catch((err) => {
        const errorMessage = err.response?.data?.message || err.message || "Unknown error occurred";
        dispatch(versionsError(errorMessage));
      });
  };
};

